
export default function GenericHead()
{
    return <>
<meta name="viewport" content="initial-scale=1, width=device-width" />
</>
}
